import DotChart from './dot-chart';
export default DotChart;
